import React, { Component } from 'react';
import { toast } from 'react-toastify';

import Spinner from 'components/Spinner';
import UpdateServiceCodesForm from './UpdateServiceCodesForm';
import BaseModal from '../BaseModal';

import styles from './styles.module.scss';

class UpdateServiceCodesModal extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    this.loadServiceCodes();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isOpen &&
      !this.props.serviceCodes?.length &&
      !this.state.loading
    ) {
      this.loadServiceCodes();
    }
  }

  loadServiceCodes = () => {
    const { fetchServiceCodes, isOpen, sub } = this.props;
    if (isOpen) {
      this.setState({ loading: true, test: true });
      fetchServiceCodes(sub.vendor)
        .catch((e) => {
          toast.error('Failed to load vendor service codes');
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    }
  };

  handleUpdateServiceCodes = (values) => {
    const { sub, updateServiceCodes, closeModal } = this.props;

    const updatedServiceCodes = Object.entries(values).reduce((acc, item) => {
      if (item[1]) {
        acc.push(item[0]);
      }
      return acc;
    }, []);

    this.setState({ loading: true });
    return updateServiceCodes(sub.id, { service_codes: updatedServiceCodes })
      .then(() => {
        closeModal();
        toast.success('Service codes updated');
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { isOpen, closeModal, serviceCodes, subServiceCodes } = this.props;
    const { loading } = this.state;

    const initialValues = {};
    if (subServiceCodes) {
      subServiceCodes.forEach((code) => {
        initialValues[code] = true;
      });
    }

    return (
      <BaseModal
        isOpen={isOpen}
        title="Modify Service Codes"
        onClose={closeModal}
        className={styles.modal}
        confirmBtnText=""
        cancelBtnText=""
      >
        <UpdateServiceCodesForm
          initialValues={initialValues}
          onSubmit={this.handleUpdateServiceCodes}
          serviceCodes={serviceCodes}
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default UpdateServiceCodesModal;
